export default "__VITE_ASSET__Dtui2FNh__"